import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Select2Module } from 'ng-select2-component';
import { CpmComponent } from '../../cpm/cpm.component';
import { SpecificDataComponent } from '../../specific-data.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-defuncion-form',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, Select2Module, TranslateModule, CpmComponent, CommonModule],
  templateUrl: './defuncion-form.component.html',
  styleUrl: './defuncion-form.component.css'
})
export class DefuncionFormComponent extends SpecificDataComponent implements OnInit {
  @ViewChild(CpmComponent) cpmComponent!: CpmComponent;
  personForm!: FormGroup;
  searchType: string = 'documento';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.personForm = new FormGroup({
      searchType: new FormControl('documento', Validators.required),
      identifier: new FormControl(null),
      birthDate: new FormControl(null),
      nombre: new FormControl(null, Validators.required),
      apellido1: new FormControl(null, Validators.required),
      apellido2: new FormControl,
      deathDate: new FormControl(null),
      selfDeclaration: new FormControl(false, [Validators.requiredTrue]),
      motivoConsulta: new FormControl('', [Validators.required, Validators.pattern(/.*\S.*/)])
    });

    this.listenSearchTypeChanges();
  }

  regex = /^[A-Za-z]{2}\/[A-Za-z]{2}\//;

  private listenSearchTypeChanges(): void {
    this.personForm.get('searchType')?.valueChanges.subscribe(type => {

      this.searchType = type;
      this.personForm.get('selfDeclaration')?.setValue(false);
      this.personForm.get('motivoConsulta')?.setValue('');

      this.clearDynamicValidators();

      if (type === 'documento') {
        this.personForm.get('identifier')?.setValidators([Validators.required]);
        this.personForm.get('nombre')?.setValidators([Validators.required]);
        this.personForm.get('apellido1')?.setValidators([Validators.required]);
      }

      if (type === 'defuncion') {
        this.personForm.get('nombre')?.setValidators([Validators.required]);
        this.personForm.get('apellido1')?.setValidators([Validators.required]);
        this.personForm.get('birthDate')?.setValidators([Validators.required]);
        this.personForm.get('deathDate')?.setValidators([Validators.required]);
      }

      this.personForm.updateValueAndValidity();
    });

    this.personForm.get('searchType')?.updateValueAndValidity();
  }

  private clearDynamicValidators(): void {
    const dynamicFields = [
      'identifier',
      'nombre',
      'apellido1',
      'birthDate',
      'deathDate'
    ];

    dynamicFields.forEach(field => {
      this.personForm.get(field)?.clearValidators();
      this.personForm.get(field)?.updateValueAndValidity({ emitEvent: false });
    });
  }

  get selfDeclarationSelected(): boolean {
    return this.personForm.get('selfDeclaration')?.value;
  }

  override getValue() {
    this.specificData.nombre = this.personForm.controls['nombre'].value;
    this.specificData.apellido1 = this.personForm.controls['apellido1'].value;
    this.specificData.apellido2 = this.personForm.controls['apellido2'].value;
    this.specificData.consultaTerceros = true;

    if (this.searchType === 'documento') {
      this.specificData.identifier = this.personForm.controls['identifier'].value;
    }

    if (this.searchType === 'defuncion') {
      this.specificData.codeComunidad = this.cpmComponent.selectedComunidad?.codigo;
      this.specificData.codeProvincia = this.cpmComponent.selectedProvincia?.codigo;
      this.specificData.codeMunicipio = this.cpmComponent.selectedMunicipio?.codigo;
      this.specificData.birthDate = this.personForm.controls['birthDate'].value;
      this.specificData.fechaHechoRegistral = this.personForm.controls['deathDate'].value;
    }

    this.specificData.motivoConsulta = this.personForm.controls['motivoConsulta'].value;
    return this.specificData;
  }

  override isValid(): boolean {
    if (this.searchType === 'documento' && this.personForm?.valid) return true;
    if (this.searchType === 'defuncion' && this.personForm?.valid && this.cpmComponent?.isValid()) return true;
    return false;
  }
}
